<button
  type="button"
  class="btn btn-transparent text-white position-relative"
  ngbTooltip="{{ 'GLOBAL_TOOLBAR.HELP' | translate }}"
>
  <i class="bi bi-question-circle"></i>
</button>
